import QueryFilter from 'components/Table/components/QueryFilter'
import IconButton from '@mui/material/IconButton'
import Link from '@mui/material/Link'

import { NETWORK_ACTION } from './hooks'

const renderFilter = (info) => <QueryFilter key='FilterInput' {...info} />

export const getColumns = (setSelectedNetwork) => ([
  {
    Header: '',
    accessor: '_update-action',
    Cell: ({ row }) => {
      return (
        <IconButton
          onClick={() => {
            setSelectedNetwork({ ...row.original, _type: NETWORK_ACTION.UPDATE })
          }}
          size={'small'}
          style={{ margin: '0 8px', color: '#1976d2' }}
        >
          <i className='fas fa-edit' />
        </IconButton>
      )
    },
    disableFilters: true,
  },
  {
    Header: 'ID',
    accessor: 'id',
    sortType: 'alphanumericCustom',
    Filter: renderFilter,
  },
  {
    Header: 'Name',
    accessor: 'name',
    Filter: renderFilter,
  },
  {
    Header: 'Url',
    accessor: 'block_explorer_url',
    Cell: ({ value }) => {
      return <Link href={value} target="_blank">{value}</Link>
    },
    Filter: renderFilter,
  },
  {
    Header: '',
    accessor: '_remove-action',
    Cell: ({ row }) => {
      return (
        <IconButton
          onClick={() => {
            setSelectedNetwork({ ...row.original, _type: NETWORK_ACTION.REMOVE })
          }}
          size={'small'}
          style={{ margin: '0 8px', color: 'red' }}
        >
          <i className='fas fa-trash' />
        </IconButton>
      )
    },
    disableFilters: true,
  },
])
